
import { useState, useEffect } from "react";
import { SchoolUser } from "@/types/users";
import { supabase } from "@/integrations/supabase/client";

export const useUserStatus = (users: SchoolUser[]) => {
  const [usersWithStatus, setUsersWithStatus] = useState<(SchoolUser & {
    hasUnpaidBills?: boolean;
    hasActiveSubscription?: boolean;
  })[]>(users);

  useEffect(() => {
    const checkStatus = async () => {
      console.log('Checking status for users:', users);
      const updatedUsers = await Promise.all(
        users.map(async (user) => {
          const { data: unpaidBills, error: billError } = await supabase
            .from('bills')
            .select('id')
            .eq('school_id', user.school_id)
            .eq('status', 'unpaid')
            .limit(1);

          const { data: clientData, error: clientError } = await supabase
            .from('clients')
            .select('id')
            .eq('school_id', user.school_id)
            .maybeSingle();

          let activeSubscriptions = null;
          let subError = null;
          
          if (clientData?.id) {
            const subscriptionResult = await supabase
              .from('subscriptions')
              .select('id')
              .eq('client_id', clientData.id)
              .eq('status', 'active')
              .limit(1);
            
            activeSubscriptions = subscriptionResult.data;
            subError = subscriptionResult.error;
          }

          if (billError || clientError || subError) {
            console.error('Error checking status:', { billError, clientError, subError });
            return {
              ...user,
              hasUnpaidBills: false,
              hasActiveSubscription: false
            };
          }

          const hasUnpaidBills = unpaidBills && unpaidBills.length > 0;
          const hasActiveSubscription = activeSubscriptions && activeSubscriptions.length > 0;

          console.log(`User ${user.email} status:`, {
            hasUnpaidBills,
            hasActiveSubscription,
            unpaidBills,
            activeSubscriptions,
            clientId: clientData?.id
          });

          return {
            ...user,
            hasUnpaidBills,
            hasActiveSubscription
          };
        })
      );

      console.log('Updated users with status:', updatedUsers);
      setUsersWithStatus(updatedUsers);
    };

    checkStatus();
  }, [users]);

  return { usersWithStatus };
};
